import css from 'styled-jsx/css';
import { colors, icons } from '../../config/styles';
import { svgToDataUri } from '../../utils/styles/svgMixins';

const WarrantyStyles = css`
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    padding-bottom: 16px;
    border-bottom: 1px solid ${colors.gray.shade2};
  }

  .header-mobile {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 16px;
    padding-bottom: 8px;
  }

  .title {
    font-size: 20px;
    font-weight: 700;
    color: ${colors.black.shade1};
    margin: 0;
  }

  .close-button {
    background: none;
    border: none;
    cursor: pointer;
    font-size: 20px;
  }

  .product-info,
  .product-info-mobile {
    display: flex;
    margin-bottom: 20px;
    padding-bottom: 16px;
    border-bottom: 1px solid ${colors.gray.shade2};
  }

  .product-info-mobile {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .product-image {
    width: 80px;
    height: 80px;
    margin-right: 16px;
    flex-shrink: 0;
  }

  .product-image img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .product-info-mobile .product-image {
    margin-right: 0;
    margin-bottom: 8px;
  }

  .product-details {
    display: flex;
    flex-direction: column;
  }

  .brand-name {
    font-size: 14px;
    font-weight: 700;
    color: ${colors.black.shade1};
    text-transform: uppercase;
    margin: 0 0 4px 0;
  }

  .display-name {
    font-size: 16px;
    color: ${colors.black.shade1};
    margin: 0;
  }

  .sub-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 16px;
    padding: 12px 0;
    width: 100%;
  }

  .sub-footer :global(button) {
    align-self: center;
    width: auto;
  }

  .drawer-sub-footer {
    display: flex;
    flex-direction: column-reverse;
    gap: 8px;
    margin-top: 16px;
    padding: 16px 0;
    width: 100%;
  }

  .drawer-sub-footer .submit {
    width: 100%;
    margin-bottom: 8px;
  }

  .drawer-sub-footer .submit :global(button) {
    width: 100%;
  }

  .cancel {
    display: flex;
    height: 40px;
    padding: 0 32px;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
    cursor: pointer;
    background: none;
    border: none;
  }

  .drawer-sub-footer .cancel {
    width: 100%;
    text-align: center;
    text-decoration: none;
    border: 1px solid ${colors.gray.shade2};
    border-radius: 4px;
  }

  .submit {
    display: flex;
    justify-content: flex-end;
  }

  /* Estilos del contenedor de garantía */
  .warranty-container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: baseline;
    padding-bottom: 12px;
    gap: 12px;
  }

  .warranty-container .title {
    display: flex;
    gap: 8px;
    align-items: center;
    font-size: 14px;
    font-weight: 700;
    line-height: 16px;
  }

  .warranty-container .title .warranty-icon {
    display: flex;
    height: 20px;
    min-width: 20px;
    background-image: url('${icons.warrantyIcon ? svgToDataUri(icons.warrantyIcon) : ''}');
    background-size: 100%;
    background-position: center;
  }

  .highlighted-warranty {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    padding: 0 4px;
    font-size: 12px;
    line-height: 16px;
    width: 100%;
    font-weight: 400;
  }

  .highlighted-warranty .label {
    display: flex;
    gap: 8px;
    width: 60%;
  }

  .highlighted-warranty .label .warranty-name {
    font-size: 12px;
    line-height: 16px;
    font-weight: 400;
  }

  .highlighted-warranty .label .checkbox {
    display: flex;
    height: 20px;
    min-width: 20px;
    background-size: 100%;
    background-position: center;
  }

  .highlighted-warranty .label .checkbox.full {
    background: ${colors.gray.shade64};
    border-radius: 4px;
    background-image: url('${icons.filledCheckBox ? svgToDataUri(icons.filledCheckBox) : ''}');
  }

  .highlighted-warranty .label .checkbox.empty {
    background-image: url('${icons.emptyCheckBox ? svgToDataUri(icons.emptyCheckBox) : ''}');
  }

  .highlighted-warranty .warranty-price {
    font-size: 12px;
    font-weight: 700;
    line-height: 16px;
  }

  .more-warranty-options {
    font-size: 12px;
    font-weight: 700;
    color: ${colors.gray.shade64};
    line-height: 16px;
    border-bottom: 1px solid;
  }

  .warranty-pop-up {
    position: fixed;
    inset: 0;
    display: flex;
    flex-direction: column;
    cursor: initial;
    height: 100%;
    width: 100%;
    z-index: 200;
    background-color: ${colors.black.shade13};
    justify-content: center;
    align-items: center;
  }

  .modal-content {
    position: relative;
    width: 680px;
    padding: 24px;
    height: fit-content;
    border-radius: 12px;
    overflow: auto;
    background-color: ${colors.white.shade1};
  }

  .drawer-content {
    padding: 8px 20px 20px 20px;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  @media (max-width: 768px) {
    .sub-footer {
      flex-direction: column-reverse;
      gap: 16px;
    }

    .submit {
      width: 100%;
    }

    .submit :global(button) {
      width: 100%;
    }

    .cancel {
      width: 100%;
      text-align: center;
    }
  }
`;

export { WarrantyStyles };
